import { render } from "./Placing.vue?vue&type=template&id=3608e02c"
import script from "./Placing.vue?vue&type=script&lang=ts"
export * from "./Placing.vue?vue&type=script&lang=ts"
script.render = render

export default script